import React from "react";
import Filter from "./Filter";

export default props => (
  <Filter
    width={100}
    name="budget"
    title="Budget"
    type="number"
    label={value => `Under $${value}`}
    prefix={"$"}
    placeholder={""}
    {...props}
  />
);
